import styled from 'styled-components';

export const SliderContainer = styled.div`
  position: absolute;
  bottom: 35px;
  left: -4px;
  padding-left: 12px;
  border-radius: 10px;
  background: #fff;
  width: 31px;
  border: 1px solid var(--l-grey);
  display: none;
`;

export const VolumeContainer = styled.div`
  position: relative;
  padding-top: 5px;
  color: var(--d-grey);
  transition: all 0.2s;
  &:hover {
    color: var(--accent);
  }
  @media (max-width: 800px) {
    grid-column: 2/3;
    grid-row: 1;
  }

  /* smartphones, touchscreens  */
  @media (hover: none) and (pointer: coarse) {
    display: none;
  }

  .rangeslider {
    margin: 10px 0;
    position: relative;
    background: #e6e6e6;
    touch-action: none;
    height: 100px;
    max-width: 5px;
    border-radius: 10px;
    background-color: var(--l-grey);
  }

  .rangeslider-vertical {
  }

  .rangeslider,
  .rangeslider .rangeslider__fill {
    display: block;
  }

  .rangeslider-vertical .rangeslider__fill {
    width: 100%;
    background-color: var(--accent);
    bottom: 0;
    border-radius: 0 0 10px 10px;
  }

  .rangeslider-vertical .rangeslider__fill,
  .rangeslider-vertical .rangeslider__handle {
    position: absolute;
  }

  .rangeslider .rangeslider__handle {
    outline: none;
    background: #fff;
    border: 1px solid var(--l-grey);
    cursor: pointer;
    display: inline-block;
    width: 15px;
    height: 15px;
    left: -5px;
    border-radius: 10px;
  }
  &:hover {
    ${SliderContainer} {
      display: block;
    }
  }
`;
